import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { useNavigate, useLocation } from 'react-router-dom';
import './Register.css';
//import { useAuth } from '../AuthContext';
import { Tooltip } from './Tooltip';
import { API_REGISTER_URL } from '../constants';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

const Register: React.FC = () => {
    const [firstName, setFirstName] = useState<string>('');
    const [lastName, setLastName] = useState<string>('');
    const [userName, setUserName] = useState<string>('');
    const [password, setPassword] = useState<string>('');
    const [confirmPassword, setConfirmPassword] = useState<string>('');

    const [error, setError] = useState<string>('');
    const navigate = useNavigate();
    const location = useLocation();

    useEffect(() => {
        if (location.state?.message) {
            setError(location.state.message);
        }
    }, [location.state]);

    const handleRegister = async (e: React.FormEvent) => {
        e.preventDefault();

        try {
            // Ensure passwords match before making the API call
            if (password !== confirmPassword) {
                setError('Die Passwörter stimmen nicht überein. Bitte überprüfen Sie Ihre Eingaben.');
                window.scrollTo({ top: 0, behavior: 'smooth' });
                return;
            }

            const registerPromise = axios.post(API_REGISTER_URL, {
                firstname: firstName,
                lastname: lastName,
                username: userName,
                password,
            });

            toast.promise(
                registerPromise,
                {
                    pending: 'Registrierung läuft...',
                    success: 'Registrierung erfolgreich!',
                    error: 'Registrierung fehlgeschlagen. Bitte kontrollieren Sie Ihre Daten und versuchen Sie den Vorgang noch einmal.'
                }
            ).then(() => {
                setTimeout(() => {
                    navigate('/activation', { state: { from: '/register' } });
                    window.scroll(0, 0);
                }, 250);
            });


        } catch (error) {
            setError('Registrierung fehlgeschlagen. Bitte kontrollieren Sie Ihre Daten und versuchen Sie den Vorgang noch einmal.');
        }
    };

    return (
        <>
            <div className="empty-container">
            </div>
            <div className="auth-container">
                <div className="p-3 border-bottom-grey">
                    <h1 className="login-title">Neue Registrierung</h1>
                </div>
                <div className="p-3">
                    <p className="login-subtitle">
                        Reichen Sie mit Ihrer Registrierung einen neuen Nostrifizierungs-Antrag ein.
                    </p>
                    {error && <div className="alert alert-danger">{error}</div>}
                    <form onSubmit={handleRegister}>
                        <div className='personal-data'>
                            <h4 >Persönliche Daten </h4>
                            <div className="form-group">
                                <label htmlFor='firstName' className='form-top'>Vorname</label>
                                <input
                                    id='firstName'
                                    className="form-control"
                                    type="text"
                                    placeholder="Ihr Vorname"
                                    value={firstName}
                                    onChange={(e) => setFirstName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor='lastName'>Nachname</label>
                                <input
                                    id='lastName'
                                    className="form-control"
                                    type="text"
                                    placeholder="Ihr Nachname"
                                    value={lastName}
                                    onChange={(e) => setLastName(e.target.value)}
                                    required
                                />
                            </div>
                        </div>
                        <div className='access-data'>
                            <h4 >Zugangsdaten festlegen </h4>
                            <div className="form-group">
                                <label htmlFor='userName' className='form-top'>Benutzername (E-Mail-Adresse)</label>
                                <input
                                    id='userName'
                                    autoComplete="email"
                                    className="form-control"
                                    type="email"
                                    placeholder="Ihre E-Mail-Adresse"
                                    value={userName}
                                    onChange={(e) => setUserName(e.target.value)}
                                    required
                                />
                            </div>
                            <div className="form-group">
                                <label htmlFor='registerPassword'>Neues Passwort</label>
                                <Tooltip text="Das Passwort muss mindestens 8 Zeichen lang sein">
                                    <input
                                        id='registerPassword'
                                        className="form-control"
                                        type="password"
                                        placeholder="Neues Passwort"
                                        value={password}
                                        onChange={(e) => setPassword(e.target.value)}
                                        required
                                    />
                                </Tooltip>
                            </div>
                            <div className="form-group">
                                <label htmlFor='confirmPassword'>Neues Passwort bestätigen</label>
                                <input
                                    id='confirmPassword'
                                    className="form-control"
                                    type="password"
                                    placeholder="Bestätigen Sie Ihr neues Passwort"
                                    value={confirmPassword}
                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                    required
                                    readOnly={password.length < 8 && confirmPassword === ''}
                                />
                            </div>
                        </div>
                        <div className="form-group bt">
                            <button className="login-button" type="submit" disabled={(firstName && lastName
                                && userName && password && confirmPassword) === ''} >Jetzt registrieren</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default Register;